import {
  CONTENT_LAYOUT_OPTIONS,
  HEADING_ALIGNMENT_OPTIONS,
  MODULE_FLOW_DIRECTION_OPTIONS,
  TITLE_SIZE_OPTIONS,
  TITLE_TYPE_OPTIONS,
} from '@/common/constants';
import { useModuleStyles } from '@/common/hooks';
import { BaseModuleProps } from '@/common/types';
import { HeadingBlock, HeadingBlockProps } from '@/components/blocks/HeadingBlock/HeadingBlock';
import classNames from 'classnames';
import React from 'react';
import { ExpansionItem } from './ExpansionItem';
import { ExpansionItemProps } from './ExpansionItem/ExpansionItem';
import styles from './ExpansionPanel.module.scss';

export interface ExpansionPanelProps extends BaseModuleProps {
  panels: ExpansionItemProps[];
}

export const ExpansionPanel: React.FC<ExpansionPanelProps> = ({
  anchorTag = undefined,
  container,
  fillType,
  gradientFillToken,
  layout = CONTENT_LAYOUT_OPTIONS.CONTENT_TRAILING,
  flowDirection = MODULE_FLOW_DIRECTION_OPTIONS.COLUMN,
  eyebrow,
  title,
  titleSize = TITLE_SIZE_OPTIONS.LARGE,
  titleType = TITLE_TYPE_OPTIONS.H2,
  bodyRichTextAsHTML,
  alignment = HEADING_ALIGNMENT_OPTIONS.START,
  ctas,
  caption,
  panels,
}) => {
  const headingConfig: HeadingBlockProps = {
    eyebrow,
    title,
    titleSize,
    titleType,
    bodyRichTextAsHTML,
    alignment,
    ctas,
    caption,
  };

  // Use the common module styles hook
  const { sectionStyles, moduleBaseStyles } = useModuleStyles({
    container,
    fillType,
    gradientFillToken,
    layout,
    flowDirection,
    moduleClassName: 'module-expansion-panel',
    styles,
  });

  return (
    <section className={sectionStyles} id={anchorTag}>
      <div className={moduleBaseStyles}>
        <HeadingBlock {...headingConfig} />
        <div className={classNames(styles['expansion-item-list'], styles['module-content-swap'])}>
          {panels.map((panel, idx) => (
            <ExpansionItem key={idx} {...panel} />
          ))}
        </div>
      </div>
    </section>
  );
};
